/**
 * Drop-in overlay during `between-hands`. Sits on top of the (disabled)
 * ActionBar so the page layout doesn't shift — just a big chunky
 * "NEXT HAND" pixel-arcade CTA appears over the dim controls.
 */

export type HandEndNextButtonProps = {
  onNext: () => void;
};

export function HandEndNextButton({ onNext }: HandEndNextButtonProps) {
  return (
    <div
      className="absolute inset-x-0 bottom-0 z-30 px-4 pb-4 pointer-events-none"
      data-testid="hand-end-next-footer"
    >
      <button
        type="button"
        onClick={onNext}
        className="pointer-events-auto w-full rounded-sm py-5 font-display text-lg uppercase tracking-[0.35em] border-2 border-warning bg-warning text-bg-deeper hover:brightness-110 active:translate-y-0.5 transition-all shadow-[4px_4px_0_0_hsl(var(--color-warning)/0.75),0_0_24px_hsl(var(--color-warning)/0.4)] hover:shadow-[5px_5px_0_0_hsl(var(--color-warning)/0.75),0_0_32px_hsl(var(--color-warning)/0.5)]"
        data-testid="hand-end-next"
      >
        ▶ Next Hand
      </button>
    </div>
  );
}
